import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appTransaction',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "There hasn't been a transaction yet.",
  fields: [
    {
      attributeName: 'ip',
      label: 'IP',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'IP address from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'130px'

    },
    {
      attributeName: 'country',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      helpText: 'Country from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'100px'
    },
    {
      attributeName: 'userValidationCode',
      label: 'Code Used',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Transaction code used',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'150px'
    },
    {
      attributeName: 'deviceId',
      label: 'Device ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'ID of the device used',
    },
    {
      attributeName: 'platform',
      label: 'Platform',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Platform of the device used',
      exactWidth:'100px'
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.SELECT,
      helpText: 'Transaction status, the transactino can be revoked to enabled a token other time',
      options: [
        { name: 'Active', value: 'active' },
        { name: 'Revoked', value: 'revoked' },
      ],
      default: '',
      width: '10rem',
      exactWidth:'135px',
      canEdit: true,
      canCreate: false,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'used',
      label: 'Num. of Uses',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Number of uses of this token till the date',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      exactWidth:'50px'
    },
    {
      attributeName: 'providerApp',
      label: 'Associated Provider',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Virtual ticket provider.',
    },
    {
      attributeName: 'link',
      label: 'Kibana Link',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      helpText: 'Kibana external link with the device param of this row.',
      exactWidth:'50px'

    },
    {
      attributeName: 'created_at',
      label: 'Creation Date',
      type: FormInputTypes.TIMESTAMP,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Date of transaction creation',
    },
  ],
};
